import React from 'react';

const NewBooking = React.lazy(() => import('components/Booking/NewBooking'));
const OnsiteBooking = React.lazy(() => import('components/OnsiteBooking'));
const Home = React.lazy(() => import('components/Home'));
const ManageBooking = React.lazy(() =>
  import('components/Booking/ManageBooking'),
);
const NewBookingAMC360 = React.lazy(() =>
  import('components/BookingAMC360/NewBooking'),
);
const ManageBookingAMC360 = React.lazy(() =>
  import('components/BookingAMC360/ManageBooking'),
);
const Patient = React.lazy(() => import('components/Patient'));
const Package = React.lazy(() => import('components/Package'));
const Position = React.lazy(() => import('components/Position'));
const ResetPassword = React.lazy(() =>
  import('components/Login/ResetPassword'),
);

const ProjectIdentification = React.lazy(() =>
  import('components/ProjectIdentification'),
);
const ManageLogin = React.lazy(() => import('components/ManageLogin'));
const NotFound = React.lazy(() => import('components/NotFound'));

export * from './ui';

export const Title = {
  Mr: 1,
  Mrs: 2,
  Ms: 3,
  Miss: 4,
  Master: 5,
  Doctor: 6,
};

export const StaffTitleList = {
  1: 'Mr',
  2: 'Mrs',
  3: 'Ms',
  4: 'Miss',
  5: 'Master',
  6: 'Dr',
};

export const PatientTitleList = StaffTitleList;

export const StaffTypeList = {
  1: 'Healthcare Provider',
  2: 'Staff',
  3: 'Clinician',
  4: 'Client POC',
};

export const GenderList = {
  1: 'Male',
  2: 'Female',
};

export const CardColourList = {
  1: 'White',
  2: 'Gold',
  3: 'Orange',
};

export const Format = {
  Time: 'HH:mm',
  Date: 'DD/MM/YYYY',
  YearFirstDateFormat: 'YYYY-MM-DD',
  DateHyphenFormat: 'DD-MM-YYYY',
  Month: 'MM/YYYY',
  DateTime: 'DD/MM/YYYY HH:mm',
};

export const AccountStatusList = { 1: 'Active', 0: 'InActive' };

export const AccountStatus = { ACTIVE: 1, INACTIVE: 0 };

export const StateList = [
  { key: 'New South Wales', value: 'New South Wales' },
  { key: 'Queensland', value: 'Queensland' },
  { key: 'South Australia', value: 'South Australia' },
  { key: 'Tasmania', value: 'Tasmania' },
  { key: 'Victoria', value: 'Victoria' },
  { key: 'Western Australia', value: 'Western Australia' },
  { key: ' Northern Territory', value: ' Northern Territory' },
  {
    key: 'Australian Capital Territory',
    value: 'Australian Capital Territory',
  },
];

export const CountryList = [
  { key: 'Australia', value: 'Australia' },
  { key: 'Viet Nam', value: 'Viet Nam' },
];

// export const Features = {
//   PatientProfile: 1,
//   StaffManagement: 2,
//   AccountManagement: 3,
//   Scheduler: 4,
//   User: 5,
//   Role: 6,
//   Staff: 7,
//   Company: 8,
//   CompanySite: 9,
//   CompanyPO: 10,
//   System: 11,
//   SystemAdmin: 19,
//   ClientCompanyAdmin: 20,
//   ProjectIdentification: 22,
// };

export const ViewType = {
  day: 'day',
  month: 'month',
  week: 'week',
};

export const DiffTimeInterval = {
  value: 5,
};

export const DayInWeeks = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const RelationshipList = {
  1: 'Parent',
  2: 'Parent-in-law',
  3: 'Spouse',
  4: 'Partner',
  5: 'Daughter',
  6: 'Son',
  7: 'Brother',
  8: 'Sister',
  9: 'Friend',
  10: 'Other',
};

export const ContactRoleList = {
  1: 'Primary Contact',
  2: 'Secondary Contact',
};

export const stateEvent = {
  enabled: 1,
  disable: 0,
};

export const Clinic = {
  1: 'REDiMED Belmont',
  2: 'REDiMED Joondalup',
  4: 'REDiMED Rockingham',
  5: 'Bethesda Hospital',
  6: 'Mole Patrol Bibra Lake',
  7: 'FSH',
  8: 'Glengary Hospital',
  9: 'Hollywood Private Hospital',
  10: 'Sculpt Nedlands',
  11: 'Sculpt Joondalup',
  12: 'JHC',
  13: 'Onsite',
};

export const FeatureId = {
  MEDICAL_ONLINE_BOOKING: 18,
  PROJECT_IDENTIFICATION: 22,
  PO_BOOKING: 24,
  PUBLIC_ONLINE_BOOKING: 25,
  BOOKING_PEM: 29,
  BOOKING_AMC360: 30,
  MANAGE_BOOKING: 31,
  CANDIDATE: 37,
  ORGANISATION_CANDIDATE: 32,
  PACKAGE: 33,
  POSITION: 34,
  MANAGE_COMPANY: 35,
  MANAGE_LOGIN: 42,
};

export const ActionPermission = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
};

export const RaceEthnicityList = {
  1: 'Non-Aboriginal',
  2: 'Aboriginal & Indigenous',
};

export const CardColorList = {
  1: 'White',
  2: 'Gold',
  3: 'Orange',
};

export const ReferralType = {
  1: 'Received',
  2: 'Send',
};

export const LetterType = {
  1: 'OP NOTE',
  2: 'Letter',
  3: 'Instruction',
};

export const SendEmailTargetTypeList = [
  {
    key: 1,
    value: 'Clinician',
  },
  {
    key: 2,
    value: 'Organisation',
  },
  {
    key: 3,
    value: 'Client POC',
  },
  {
    key: 4,
    value: 'Patient',
  },
];

export const Carrier = {
  HEALTHLINK: 1,
  EMAIL: 2,
};

export const TimeEnum = {
  DayInWeeksNo: 7,
  TimeMinSelectZone: 5,
  TimeInHours: 60,
  TimeUnixMillisecond: 1000,

  defaultTimeWorkingStartTime: 8,
  defaultTimeWorkingEndTime: 20,
  timeToCompare: 24,
  maxMinutesLimit: 59,
  maxSecondsLimit: 59,
  defaultMinMinutesSecond: 0,
  hourExclude: 1,
  smallestTimeCalendar: 3,
};

export const AppointmentEnum = {
  commonType: 2,
  firstType: 0,
};

export const DocumentTypeExtension = '.jpg,.png,.gif,.jpeg,.docx,.pdf,.xlsx';
export const ImageTypeExtension = 'image/x-png,image/gif,image/jpeg,image/jpg';
export const ImageSizeLimit = 3000000; //3MB
export const RosterEnum = {
  multiBookingDefault: 1,
  isRecurrenceDefault: 0,
  timeIntervalDefault: 5,
  recurrenceTypeDefault: 'Daily',
};

export const AppointmentsSizeEnum = {
  minHeight: 130,
  minWidth: 50,
};

export const TEXTAREA = {
  MIN_ROWS: 5,
  MAX_ROWS: 5,
};

export const NOTIFICATION_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warn',
  INFO: 'info',
};

export const PAGING_LIMIT = 10;
export const TOTAL_LIMIT = -1;

export const BookingStatusList = {
  1: 'Pending for Confirmation',
  2: 'Confirmed',
  3: 'Rescheduled',
  4: 'Cancelled',
  // 5: 'DVA',
  // 6: 'Checked in',
  // 7: 'Billed',
  // 8: 'Checked out',
};

export const BOOKING_STATUS_ENUM = {
  PENDING_FOR_CONFIRMATION: 1,
  CONFIRM: 2,
  RESCHEDULED: 3,
  CANCELLED: 4,
  DVA: 5,
  CHECKED_IN: 6,
  BILLED: 7,
  CHECKED_OUT: 8,
};

export const BOOKING_TYPE = {
  MOB: 'mob',
  AMC360: 'amc360',
  FITTEST: 'fittest',
};

export const PACKAGE_TYPE = {
  FITTEST: 1,
};

export const BOOKING_SERVICE_LIST = {
  PEM: [
    {
      key: 1,
      label: 'PEM',
    },
  ],
  AMC360: [
    {
      key: 4,
      label: 'AMC360',
    },
  ],
};

export const StorageType = {
  AuthInfo: 'AUTH_INFO',
  Features: 'FEATURES',
  OrganisationDetail: 'ORGANISATION_DETAIL_INFO',
  StaffDetail: 'STAFF_DETAIL_INFO',
  OnsiteBookingInfo: 'ONSITE_BOOKING',
  CHOSEN_PACKAGE: 'CHOSEN_PACKAGE',
  CHOSEN_POSITION: 'CHOSEN_POSITION',
};

export const COMMUNICATION_TYPE = {
  RECEIVING_RESULT: 1,
  RECEIVING_INVOICE: 2,
};

export const ACCOUNT_TYPE = {
  CLIENT_POC: 3,
};

export const AUS_TIME_ZONE = {
  UTC800: {
    area: 'Australia/Perth',
    offset: 480, //8 x 60
  },
  UTC845: {
    area: 'Australia/Eucla',
    offset: 525,
  },
  UTC930: {
    area: 'Australia/Adelaide',
    offset: 570,
  },
  UTC1000: {
    area: 'Australia/Melbourne',
    offset: 600,
  },
};

export const TIME_ZONE_DISPLAY_TEXT = {
  UTC800: 'UTC+8:00 (AWST)',
  UTC845: 'UTC+8:45 (ACWST)',
  UTC930: 'UTC+9:30 (ACST)',
  UTC1000: 'UTC+10:00 (AEST)',
};

export const PEM_PREFERRED_TIME = {
  startTime: 7,
  endTime: 17,
  minuteStep: 15,
};

export const PROJECT_IDENTIFICATION_KEY = '1';

export const routes = [
  {
    path: '/',
    exact: true,
    name: 'Home',
    component: Home,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    isPublic: true,
    component: ResetPassword,
  },
  {
    path: '/make-booking/new-booking',
    name: 'New Booking',
    component: NewBooking,
    featureId: 29,
  },
  {
    path: '/make-booking/amc360-booking',
    name: 'New Booking - AMC360',
    component: NewBookingAMC360,
    featureId: 30,
  },
  {
    path: '/onsite-booking',
    name: 'New Booking',
    component: OnsiteBooking,
    isPublic: true,
    featureId: 0,
  },
  {
    path: '/manage-booking/amc360',
    name: 'Edit Booking - AMC360',
    component: ManageBookingAMC360,
  },
  {
    path: '/manage-booking',
    name: 'Manage Bookings',
    component: ManageBooking,
    featureId: 31,
  },
  {
    path: '/patient',
    name: 'Candidates/Patients',
    component: Patient,
    featureId: 32,
  },
  {
    path: '/package',
    name: 'Packages',
    component: Package,
    featureId: 33,
  },
  {
    path: '/position',
    name: 'Positions',
    component: Position,
    featureId: 34,
  },
  {
    path: '/project-identification',
    name: 'Project Identification',
    component: ProjectIdentification,
    featureId: 22,
  },
  {
    path: '/project-identification',
    name: 'Project Identification',
    component: ProjectIdentification,
    featureId: 22,
  },
  {
    path: '/project-identification',
    name: 'Project Identification',
    component: ProjectIdentification,
    featureId: 37,
  },
  {
    path: '/manage-login',
    name: 'Login Management',
    component: ManageLogin,
    featureId: 42,
  },
  {
    path: '/404',
    isPublic: true,
    name: '404 Not Found',
    component: NotFound,
  },
  {
    path: '*',
    isPublic: true,
    name: '404 Not Found',
    component: NotFound,
  },
];

export const PHONE_PREFIX_LIST = ['+02', '+03', '+04', '+07', '+08'];

export const PHONE_PREFIX_DEFAULT = PHONE_PREFIX_LIST[4];
